export const LOADED_BOOKS = 'books/loaded_books';
export const ADD_BOOK = 'books/add_book';
export const REMOVE_BOOK = 'books/remove_book';
export const UPDATE_BOOK = 'books/update_book';
export const SET_BOOK = 'books/set_book';
export const FEATURED_BOOKS = 'books/featured_books';
export const SEARCH_BOOKS = 'books/search_books';
export const LOADING_BOOKS = 'books/loading_books';
export const ERROR_BOOKS = 'books/error_books';

